import { TextField } from '@mui/material';
import { DatePickerProps, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import React from 'react';

type TDatePickerProps = Omit<DatePickerProps<Dayjs, Dayjs>, 'renderInput'> & {
  label?: string;
  value?: Dayjs | null;
  onChange?: (value: Dayjs | null) => void;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

export const DatePicker: React.FC<TDatePickerProps> = ({
  label,
  value,
  onChange,
  fullWidth = true,
  size,
  ...rest
}) => {

  return (
    <MuiDatePicker
      {...rest}
      label={label}
      value={value}
      onChange={onChange}
      inputFormat="DD/MM/YYYY"
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth={fullWidth}
          size={size}
          inputProps={{
            ...params.inputProps,
            readOnly: true,
            placeholder: 'dd/mm/aaaa'
          }}
        />
      )}
    />
  );
};
